import type React from 'react'
import { PromoBanner } from './PromoBanner'
import { StationDetailsCopy, type StationDetailsCopySet } from '../copy'

export interface TimetableUpsellBannerProps {
  onTap: () => void
  /** Localised copy. @defaultValue {@link StationDetailsCopy} */
  copy?: StationDetailsCopySet
}

/**
 * Premium upsell banner — Figma SD/TimetableUpsellBanner (6974:29525), a
 * {@link PromoBanner} with the "Get Premium" copy. a11y id
 * `station-details-timetable-upsell-banner`.
 */
export function TimetableUpsellBanner({
  onTap,
  copy = StationDetailsCopy,
}: TimetableUpsellBannerProps): React.ReactElement {
  return (
    <PromoBanner
      title={copy.TimetableUpsellBannerTitle}
      description={copy.TimetableUpsellBannerDescription}
      cta={copy.TimetableUpsellBannerButton}
      onTap={onTap}
      testId="station-details-timetable-upsell-banner"
    />
  )
}
